/* eslint-disable no-console */
/* eslint-disable unicorn/no-console-spaces */
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { AchsJWT } from '@ui-core/interfaces/AchsJWTInterface';

/**
 * Set expiration access token date.
 *
 * @param {string} accessToken - Bearer token.
 * @param {boolean} getString - If you wan't the expiration access token date.
 *
 * @returns {void | string} The expiration token date.
 */
export const setExpirationAccessTokenDate = (
    accessToken: string,
    getString = false
): void | string => {
    let tokenPayloadDecode = {} as AchsJWT;
    let tokenIsValid = false;
    try {
        tokenPayloadDecode = jwtDecode(accessToken);
        tokenIsValid = true;
    } catch (error: any) {
        console.log('Access token decode error: ', error.message);
    }

    if (tokenIsValid) {
        const { iat, exp } = tokenPayloadDecode;
        const issuedAt = moment.unix(iat);
        const expirationTime = moment.unix(exp);

        const timer = expirationTime.diff(issuedAt, 'seconds');
        const expirationDate = moment().unix() + timer;

        if (!getString) {
            localStorage.setItem(
                'expirationAccessTokenDate',
                `${expirationDate}`
            );
        } else {
            return `${expirationDate}`;
        }
    }
};
